"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOfferUnderPropertyDto = instanceOfOfferUnderPropertyDto;
exports.OfferUnderPropertyDtoFromJSON = OfferUnderPropertyDtoFromJSON;
exports.OfferUnderPropertyDtoFromJSONTyped = OfferUnderPropertyDtoFromJSONTyped;
exports.OfferUnderPropertyDtoToJSON = OfferUnderPropertyDtoToJSON;
exports.OfferUnderPropertyDtoToJSONTyped = OfferUnderPropertyDtoToJSONTyped;
var OfferUnderPropertyMediaDto_1 = require("./OfferUnderPropertyMediaDto");
var OfferUnderPropertyLocationDto_1 = require("./OfferUnderPropertyLocationDto");
/**
 * Check if a given object implements the OfferUnderPropertyDto interface.
 */
function instanceOfOfferUnderPropertyDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function OfferUnderPropertyDtoFromJSON(json) {
    return OfferUnderPropertyDtoFromJSONTyped(json, false);
}
function OfferUnderPropertyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'location': json['location'] == null ? undefined : (0, OfferUnderPropertyLocationDto_1.OfferUnderPropertyLocationDtoFromJSON)(json['location']),
        'media': json['media'] == null ? undefined : (0, OfferUnderPropertyMediaDto_1.OfferUnderPropertyMediaDtoFromJSON)(json['media']),
    };
}
function OfferUnderPropertyDtoToJSON(json) {
    return OfferUnderPropertyDtoToJSONTyped(json, false);
}
function OfferUnderPropertyDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'location': (0, OfferUnderPropertyLocationDto_1.OfferUnderPropertyLocationDtoToJSON)(value['location']),
        'media': (0, OfferUnderPropertyMediaDto_1.OfferUnderPropertyMediaDtoToJSON)(value['media']),
    };
}
